/* Auto-generated by build_brand_discipline_map.py — do not hand-edit. */
window.GARA_BRAND_DISC = {
  "moto-bearings": {
    "all-balls-racing": [
      "moto",
      "mx",
      "unspecified"
    ],
    "prox": [
      "moto",
      "mx"
    ],
    "woodcraft": [
      "unspecified"
    ]
  },
  "moto-bearings-chain-rollers": {
    "all-balls-racing": [
      "moto",
      "mx"
    ],
    "prox": [
      "moto",
      "mx"
    ]
  },
  "moto-bearings-engine": {
    "woodcraft": [
      "unspecified"
    ]
  },
  "moto-bearings-linkage": {
    "all-balls-racing": [
      "moto",
      "mx"
    ]
  },
  "moto-bearings-steering": {
    "all-balls-racing": [
      "moto",
      "mx"
    ]
  },
  "moto-bearings-swingarm": {
    "all-balls-racing": [
      "moto",
      "mx",
      "unspecified"
    ]
  },
  "moto-bearings-wheel": {
    "all-balls-racing": [
      "moto",
      "mx"
    ],
    "woodcraft": [
      "unspecified"
    ]
  },
  "moto-brakes": {
    "all-balls-racing": [
      "moto",
      "mx"
    ],
    "asv": [
      "unspecified"
    ],
    "brembo": [
      "moto"
    ],
    "ebc": [
      "moto",
      "mx"
    ],
    "jt-sprockets": [
      "moto",
      "mx"
    ],
    "vesrah": [
      "moto",
      "mx"
    ],
    "woodcraft": [
      "unspecified"
    ]
  },
  "moto-brakes-calipers": {
    "brembo": [
      "moto"
    ]
  },
  "moto-brakes-hardware": {
    "all-balls-racing": [
      "moto",
      "mx"
    ],
    "asv": [
      "unspecified"
    ],
    "brembo": [
      "moto"
    ],
    "ebc": [
      "moto"
    ],
    "woodcraft": [
      "unspecified"
    ]
  },
  "moto-brakes-master-cylinder": {
    "brembo": [
      "moto"
    ]
  },
  "moto-brakes-pads": {
    "brembo": [
      "moto"
    ],
    "ebc": [
      "moto",
      "mx"
    ],
    "vesrah": [
      "moto",
      "mx",
      "unspecified"
    ]
  },
  "moto-brakes-rebuild-kits": {
    "all-balls-racing": [
      "moto",
      "mx"
    ]
  },
  "moto-brakes-rotors": {
    "brembo": [
      "moto"
    ],
    "ebc": [
      "moto"
    ],
    "jt-sprockets": [
      "moto",
      "mx"
    ]
  },
  "moto-brakes-shoes": {
    "ebc": [
      "moto",
      "mx"
    ],
    "vesrah": [
      "moto",
      "mx",
      "unspecified"
    ]
  },
  "moto-care": {
    "bike-brite": [
      "moto"
    ],
    "bio-kleen": [
      "moto",
      "mx"
    ],
    "engine-ice": [
      "moto"
    ],
    "gold-eagle": [
      "moto",
      "mx"
    ],
    "grunge-brush": [
      "moto"
    ],
    "hardline": [
      "moto"
    ],
    "klotz": [
      "moto",
      "mx"
    ],
    "liquid-performance": [
      "moto"
    ],
    "maxima": [
      "moto",
      "mx"
    ],
    "motion-pro": [
      "moto",
      "mx"
    ],
    "motorex": [
      "moto",
      "mx"
    ],
    "motul": [
      "moto",
      "mx"
    ],
    "novus": [
      "moto",
      "mx"
    ],
    "original-bike-spirits": [
      "moto"
    ],
    "performance-tool": [
      "moto"
    ],
    "pig-spit": [
      "moto",
      "mx"
    ],
    "pj1": [
      "moto",
      "mx"
    ],
    "plexus": [
      "moto",
      "mx"
    ],
    "s100": [
      "moto",
      "mx"
    ],
    "scott": [
      "moto"
    ],
    "star-brite": [
      "moto"
    ],
    "twin-air": [
      "moto"
    ]
  },
  "moto-care-cleaner": {
    "bio-kleen": [
      "moto"
    ],
    "engine-ice": [
      "moto"
    ],
    "hardline": [
      "moto"
    ],
    "ipone": [
      "moto"
    ],
    "klotz": [
      "moto",
      "mx"
    ],
    "liquid-performance": [
      "moto"
    ],
    "maxima": [
      "moto",
      "mx"
    ],
    "motion-pro": [
      "moto",
      "mx"
    ],
    "motorex": [
      "moto",
      "mx"
    ],
    "motul": [
      "moto",
      "mx"
    ],
    "original-bike-spirits": [
      "moto"
    ],
    "pig-spit": [
      "moto"
    ],
    "pj1": [
      "moto",
      "mx"
    ],
    "s100": [
      "moto",
      "mx"
    ],
    "scott": [
      "moto"
    ],
    "star-brite": [
      "moto"
    ],
    "twin-air": [
      "moto"
    ]
  },
  "moto-care-microfiber": {
    "grunge-brush": [
      "moto"
    ],
    "maxima": [
      "moto",
      "mx"
    ],
    "novus": [
      "moto"
    ],
    "performance-tool": [
      "moto"
    ],
    "s100": [
      "moto",
      "mx"
    ],
    "star-brite": [
      "moto"
    ]
  },
  "moto-care-polish": {
    "bike-brite": [
      "moto"
    ],
    "bio-kleen": [
      "moto",
      "mx"
    ],
    "engine-ice": [
      "moto"
    ],
    "gold-eagle": [
      "moto",
      "mx"
    ],
    "hardline": [
      "moto"
    ],
    "klotz": [
      "moto",
      "mx"
    ],
    "liquid-performance": [
      "moto"
    ],
    "maxima": [
      "moto",
      "mx"
    ],
    "motorex": [
      "moto",
      "mx"
    ],
    "novus": [
      "moto",
      "mx"
    ],
    "pig-spit": [
      "moto",
      "mx"
    ],
    "pj1": [
      "moto"
    ],
    "plexus": [
      "moto",
      "mx"
    ],
    "s100": [
      "moto",
      "mx"
    ],
    "star-brite": [
      "moto"
    ]
  },
  "moto-clutch": {
    "all-balls-racing": [
      "moto",
      "mx"
    ],
    "brembo": [
      "moto"
    ],
    "ebc": [
      "moto",
      "mx"
    ],
    "s-s-cycle": [
      "moto"
    ],
    "vesrah": [
      "moto",
      "mx",
      "unspecified"
    ]
  },
  "moto-clutch-baskets": {
    "s-s-cycle": [
      "moto"
    ]
  },
  "moto-clutch-hydraulics": {
    "all-balls-racing": [
      "moto",
      "mx"
    ],
    "brembo": [
      "moto"
    ]
  },
  "moto-clutch-kits": {
    "ebc": [
      "moto",
      "mx"
    ],
    "vesrah": [
      "moto",
      "mx",
      "unspecified"
    ]
  },
  "moto-clutch-springs": {
    "ebc": [
      "moto",
      "mx"
    ],
    "vesrah": [
      "moto",
      "mx"
    ]
  },
  "moto-controls": {
    "acerbis": [
      "moto"
    ],
    "asv": [
      "unspecified"
    ],
    "brembo": [
      "moto"
    ],
    "crg": [
      "moto"
    ],
    "kuryakyn": [
      "moto"
    ],
    "motion-pro": [
      "moto",
      "mx"
    ],
    "oury": [
      "moto",
      "mx"
    ],
    "renthal": [
      "moto",
      "mx"
    ],
    "vortex": [
      "moto"
    ],
    "woodcraft": [
      "unspecified"
    ]
  },
  "moto-controls-bars": {
    "kuryakyn": [
      "moto"
    ],
    "renthal": [
      "moto",
      "mx"
    ],
    "vortex": [
      "moto"
    ]
  },
  "moto-controls-clip-ons": {
    "vortex": [
      "moto"
    ],
    "woodcraft": [
      "unspecified"
    ]
  },
  "moto-controls-foot-controls": {
    "kuryakyn": [
      "moto"
    ]
  },
  "moto-controls-footpegs": {
    "kuryakyn": [
      "moto"
    ]
  },
  "moto-controls-grips": {
    "kuryakyn": [
      "moto"
    ],
    "motion-pro": [
      "moto"
    ],
    "oury": [
      "moto",
      "mx"
    ],
    "progrip": [
      "moto"
    ],
    "renthal": [
      "moto",
      "mx"
    ],
    "vortex": [
      "moto"
    ],
    "woodcraft": [
      "unspecified"
    ]
  },
  "moto-controls-levers": {
    "asv": [
      "unspecified"
    ],
    "brembo": [
      "moto"
    ],
    "crg": [
      "moto"
    ],
    "kuryakyn": [
      "moto"
    ],
    "motion-pro": [
      "moto",
      "mx",
      "unspecified"
    ],
    "vortex": [
      "moto"
    ]
  },
  "moto-controls-rearset-parts": {
    "acerbis": [
      "moto"
    ],
    "vortex": [
      "moto"
    ],
    "woodcraft": [
      "unspecified"
    ]
  },
  "moto-controls-rearsets": {
    "vortex": [
      "moto"
    ],
    "woodcraft": [
      "unspecified"
    ]
  },
  "moto-controls-throttle": {
    "kuryakyn": [
      "moto"
    ],
    "motion-pro": [
      "moto",
      "mx"
    ]
  },
  "moto-drivetrain": {
    "d-i-d": [
      "moto",
      "mx"
    ],
    "jt-sprockets": [
      "moto",
      "mx"
    ],
    "renthal": [
      "moto",
      "mx"
    ],
    "s-s-cycle": [
      "moto"
    ],
    "vortex": [
      "moto"
    ]
  },
  "moto-drivetrain-chains": {
    "d-i-d": [
      "moto",
      "mx"
    ],
    "jt-sprockets": [
      "moto"
    ],
    "vortex": [
      "moto"
    ]
  },
  "moto-drivetrain-kits": {
    "vortex": [
      "moto"
    ]
  },
  "moto-drivetrain-primary": {
    "s-s-cycle": [
      "moto"
    ]
  },
  "moto-drivetrain-sprockets": {
    "jt-sprockets": [
      "moto",
      "mx"
    ],
    "renthal": [
      "moto",
      "mx"
    ],
    "vortex": [
      "moto"
    ]
  },
  "moto-electrical": {
    "acerbis": [
      "moto"
    ],
    "all-balls-racing": [
      "moto",
      "mx"
    ],
    "antigravity": [
      "moto"
    ],
    "asv": [
      "unspecified"
    ],
    "battery-tender": [
      "moto",
      "mx"
    ],
    "get": [
      "moto"
    ],
    "kuryakyn": [
      "moto"
    ],
    "new-rage-cycles": [
      "moto"
    ],
    "tytaneum": [
      "moto"
    ],
    "woodcraft": [
      "unspecified"
    ],
    "yuasa": [
      "moto",
      "mx"
    ]
  },
  "moto-electrical-audio": {
    "kuryakyn": [
      "moto"
    ]
  },
  "moto-electrical-battery": {
    "antigravity": [
      "moto"
    ],
    "get": [
      "moto"
    ],
    "tytaneum": [
      "moto"
    ],
    "yuasa": [
      "moto",
      "mx"
    ]
  },
  "moto-electrical-charging": {
    "battery-tender": [
      "moto",
      "mx"
    ],
    "yuasa": [
      "moto",
      "mx"
    ]
  },
  "moto-electrical-other": {
    "acerbis": [
      "moto"
    ],
    "kuryakyn": [
      "moto"
    ],
    "new-rage-cycles": [
      "moto"
    ],
    "yuasa": [
      "moto",
      "mx"
    ]
  },
  "moto-electrical-switches": {
    "asv": [
      "unspecified"
    ],
    "woodcraft": [
      "unspecified"
    ]
  },
  "moto-electrical-wiring": {
    "all-balls-racing": [
      "moto",
      "mx"
    ],
    "kuryakyn": [
      "moto"
    ],
    "woodcraft": [
      "unspecified"
    ]
  },
  "moto-engine": {
    "cometic": [
      "moto",
      "mx"
    ],
    "kuryakyn": [
      "moto"
    ],
    "psychic": [
      "mx"
    ],
    "s-s-cycle": [
      "moto"
    ],
    "woodcraft": [
      "unspecified"
    ]
  },
  "moto-engine-air-intake": {
    "kuryakyn": [
      "moto"
    ]
  },
  "moto-engine-cams": {
    "s-s-cycle": [
      "moto"
    ]
  },
  "moto-engine-gaskets": {
    "cometic": [
      "moto",
      "mx"
    ],
    "psychic": [
      "mx"
    ],
    "woodcraft": [
      "unspecified"
    ]
  },
  "moto-engine-top-end": {
    "cometic": [
      "moto",
      "mx"
    ]
  },
  "moto-exhaust": {
    "acerbis": [
      "moto"
    ],
    "akrapovic": [
      "unspecified"
    ],
    "big-gun": [
      "moto",
      "mx"
    ],
    "fmf": [
      "moto",
      "mx"
    ],
    "hindle": [
      "unspecified"
    ],
    "kuryakyn": [
      "moto"
    ],
    "mivv": [
      "unspecified"
    ],
    "woodcraft": [
      "unspecified"
    ]
  },
  "moto-exhaust-full-system": {
    "akrapovic": [
      "unspecified"
    ],
    "big-gun": [
      "moto",
      "mx"
    ],
    "fmf": [
      "moto",
      "mx",
      "unspecified"
    ],
    "hindle": [
      "unspecified"
    ],
    "mivv": [
      "unspecified"
    ],
    "two-brothers": [
      "moto"
    ]
  },
  "moto-exhaust-headers": {
    "akrapovic": [
      "unspecified"
    ],
    "big-gun": [
      "moto",
      "mx"
    ],
    "fmf": [
      "mx",
      "unspecified"
    ],
    "hindle": [
      "unspecified"
    ],
    "mivv": [
      "unspecified"
    ],
    "woodcraft": [
      "unspecified"
    ]
  },
  "moto-exhaust-slip-on": {
    "akrapovic": [
      "unspecified"
    ],
    "big-gun": [
      "moto",
      "mx"
    ],
    "fmf": [
      "moto",
      "mx",
      "unspecified"
    ],
    "hindle": [
      "unspecified"
    ],
    "mivv": [
      "unspecified"
    ],
    "two-brothers": [
      "moto"
    ]
  },
  "moto-exhaust-spares": {
    "acerbis": [
      "moto"
    ],
    "akrapovic": [
      "unspecified"
    ],
    "hindle": [
      "unspecified"
    ],
    "kuryakyn": [
      "moto"
    ],
    "mivv": [
      "unspecified"
    ],
    "woodcraft": [
      "unspecified"
    ]
  },
  "moto-fuel": {
    "acerbis": [
      "moto"
    ],
    "all-balls-racing": [
      "moto"
    ],
    "ebc": [
      "moto"
    ],
    "emgo": [
      "moto",
      "mx"
    ],
    "keihin": [
      "moto",
      "mx"
    ],
    "kuryakyn": [
      "moto"
    ],
    "mikuni": [
      "moto",
      "mx"
    ],
    "motion-pro": [
      "moto",
      "mx"
    ],
    "visu-filter": [
      "moto",
      "mx"
    ],
    "vortex": [
      "moto"
    ]
  },
  "moto-fuel-caps": {
    "acerbis": [
      "moto"
    ],
    "kuryakyn": [
      "moto"
    ],
    "vortex": [
      "moto"
    ]
  },
  "moto-fuel-filters": {
    "acerbis": [
      "moto"
    ],
    "emgo": [
      "moto",
      "mx"
    ],
    "visu-filter": [
      "moto",
      "mx"
    ]
  },
  "moto-fuel-jets": {
    "ebc": [
      "moto"
    ],
    "keihin": [
      "moto",
      "mx"
    ],
    "mikuni": [
      "moto",
      "mx"
    ]
  },
  "moto-fuel-lines": {
    "all-balls-racing": [
      "moto"
    ],
    "motion-pro": [
      "moto",
      "mx"
    ]
  },
  "moto-graphics": {
    "factory-effex": [
      "mx"
    ],
    "woodcraft": [
      "unspecified"
    ]
  },
  "moto-graphics-backgrounds": {
    "factory-effex": [
      "mx",
      "unspecified"
    ]
  },
  "moto-graphics-kits": {
    "factory-effex": [
      "mx",
      "unspecified"
    ]
  },
  "moto-lines": {
    "ebc": [
      "moto"
    ],
    "goodridge": [
      "moto"
    ],
    "motion-pro": [
      "moto",
      "mx"
    ],
    "russell": [
      "moto"
    ],
    "woodcraft": [
      "unspecified"
    ]
  },
  "moto-lines-brake": {
    "ebc": [
      "moto"
    ],
    "goodridge": [
      "moto"
    ],
    "russell": [
      "moto"
    ],
    "woodcraft": [
      "unspecified"
    ]
  },
  "moto-lines-clutch-cable": {
    "motion-pro": [
      "moto"
    ]
  },
  "moto-lines-clutch-line": {
    "goodridge": [
      "moto"
    ]
  },
  "moto-maintenance": {
    "acerbis": [
      "moto"
    ],
    "all-balls-racing": [
      "moto",
      "mx"
    ],
    "athena": [
      "moto",
      "mx"
    ],
    "bikemaster": [
      "moto",
      "mx"
    ],
    "bolt": [
      "moto",
      "mx"
    ],
    "ebc": [
      "moto",
      "mx"
    ],
    "emgo": [
      "moto",
      "mx"
    ],
    "engine-ice": [
      "moto",
      "mx"
    ],
    "evans": [
      "moto",
      "mx"
    ],
    "gold-eagle": [
      "moto",
      "mx"
    ],
    "hiflofiltro": [
      "moto",
      "mx"
    ],
    "k-and-n": [
      "moto"
    ],
    "k100": [
      "moto",
      "mx"
    ],
    "klotz": [
      "moto",
      "mx"
    ],
    "kluber": [
      "moto",
      "mx"
    ],
    "kuryakyn": [
      "moto"
    ],
    "lear-chemical": [
      "moto",
      "mx"
    ],
    "len-performance": [
      "moto",
      "mx"
    ],
    "liqui-moly": [
      "moto",
      "mx"
    ],
    "lubrimatic": [
      "moto",
      "mx"
    ],
    "maier-plastics": [
      "mx"
    ],
    "maxima": [
      "moto",
      "mx"
    ],
    "motion-pro": [
      "moto",
      "mx"
    ],
    "motorex": [
      "moto",
      "mx"
    ],
    "motul": [
      "moto",
      "mx"
    ],
    "mystik": [
      "moto",
      "mx"
    ],
    "ngk": [
      "moto",
      "mx"
    ],
    "ohlins": [
      "moto"
    ],
    "performance-tool": [
      "moto",
      "mx"
    ],
    "permatex": [
      "moto",
      "mx"
    ],
    "pj1": [
      "moto",
      "mx"
    ],
    "polisport": [
      "mx"
    ],
    "profilter": [
      "moto"
    ],
    "prox": [
      "moto",
      "mx"
    ],
    "psychic": [
      "mx"
    ],
    "renthal": [
      "moto",
      "mx"
    ],
    "s-s-cycle": [
      "moto",
      "mx"
    ],
    "star-brite": [
      "moto",
      "mx"
    ],
    "three-bond": [
      "moto",
      "mx"
    ],
    "twin-air": [
      "moto",
      "mx"
    ],
    "twin-power": [
      "moto"
    ],
    "uni-filter": [
      "moto",
      "mx"
    ],
    "vibrant": [
      "moto",
      "mx"
    ],
    "woodcraft": [
      "unspecified"
    ]
  },
  "moto-maintenance-air-filter-care": {
    "klotz": [
      "moto"
    ],
    "liqui-moly": [
      "moto"
    ],
    "maxima": [
      "moto",
      "mx"
    ],
    "motorex": [
      "moto"
    ],
    "pj1": [
      "moto",
      "mx"
    ],
    "twin-air": [
      "moto",
      "mx"
    ],
    "uni-filter": [
      "moto",
      "mx"
    ]
  },
  "moto-maintenance-air-filters": {
    "acerbis": [
      "moto"
    ],
    "athena": [
      "moto",
      "mx"
    ],
    "emgo": [
      "moto"
    ],
    "hiflofiltro": [
      "moto",
      "mx"
    ],
    "k-and-n": [
      "moto"
    ],
    "profilter": [
      "moto"
    ],
    "prox": [
      "moto",
      "mx"
    ],
    "twin-air": [
      "moto",
      "mx",
      "unspecified"
    ],
    "uni-filter": [
      "moto"
    ]
  },
  "moto-maintenance-brake-fluid": {
    "ebc": [
      "moto",
      "mx"
    ],
    "ipone": [
      "moto"
    ],
    "liqui-moly": [
      "moto",
      "mx"
    ],
    "maxima": [
      "moto",
      "mx"
    ],
    "motorex": [
      "moto",
      "mx"
    ],
    "motul": [
      "moto",
      "mx"
    ]
  },
  "moto-maintenance-chain-lube": {
    "klotz": [
      "moto",
      "mx"
    ],
    "liqui-moly": [
      "moto",
      "mx"
    ],
    "maxima": [
      "moto",
      "mx"
    ],
    "motorex": [
      "moto",
      "mx"
    ],
    "motul": [
      "moto",
      "mx"
    ],
    "permatex": [
      "moto",
      "mx"
    ],
    "pj1": [
      "moto",
      "mx"
    ],
    "renthal": [
      "moto",
      "mx"
    ]
  },
  "moto-maintenance-coolant": {
    "engine-ice": [
      "moto",
      "mx"
    ],
    "evans": [
      "moto",
      "mx"
    ],
    "ipone": [
      "moto"
    ],
    "maxima": [
      "moto",
      "mx"
    ],
    "motorex": [
      "moto",
      "mx"
    ],
    "motul": [
      "moto"
    ],
    "twin-air": [
      "moto"
    ]
  },
  "moto-maintenance-drain-plugs": {
    "bikemaster": [
      "moto",
      "mx"
    ],
    "s-s-cycle": [
      "moto",
      "mx"
    ]
  },
  "moto-maintenance-engine-oil": {
    "ipone": [
      "moto"
    ],
    "klotz": [
      "moto",
      "mx"
    ],
    "liqui-moly": [
      "moto",
      "mx"
    ],
    "maxima": [
      "moto",
      "mx"
    ],
    "motorex": [
      "moto",
      "mx"
    ],
    "motul": [
      "moto",
      "mx"
    ]
  },
  "moto-maintenance-fork-oil": {
    "klotz": [
      "moto"
    ],
    "len-performance": [
      "moto",
      "mx"
    ],
    "liqui-moly": [
      "moto",
      "mx"
    ],
    "maxima": [
      "moto",
      "mx"
    ],
    "motorex": [
      "moto",
      "mx"
    ],
    "motul": [
      "moto",
      "mx"
    ],
    "ohlins": [
      "moto"
    ],
    "pj1": [
      "moto",
      "mx"
    ]
  },
  "moto-maintenance-fuel-additives": {
    "gold-eagle": [
      "moto",
      "mx"
    ],
    "k100": [
      "moto",
      "mx"
    ],
    "klotz": [
      "moto",
      "mx"
    ],
    "liqui-moly": [
      "moto",
      "mx"
    ],
    "maxima": [
      "moto",
      "mx"
    ],
    "motorex": [
      "moto",
      "mx"
    ],
    "star-brite": [
      "moto",
      "mx"
    ]
  },
  "moto-maintenance-gear-oil": {
    "ipone": [
      "moto"
    ],
    "klotz": [
      "moto"
    ],
    "liqui-moly": [
      "moto"
    ],
    "maxima": [
      "moto"
    ],
    "motorex": [
      "moto"
    ],
    "motul": [
      "moto"
    ]
  },
  "moto-maintenance-hardware": {
    "bolt": [
      "moto",
      "mx"
    ],
    "kuryakyn": [
      "moto"
    ],
    "maier-plastics": [
      "mx"
    ],
    "motion-pro": [
      "moto",
      "mx"
    ],
    "polisport": [
      "mx"
    ],
    "psychic": [
      "mx"
    ],
    "vibrant": [
      "moto",
      "mx"
    ],
    "woodcraft": [
      "unspecified"
    ]
  },
  "moto-maintenance-oil-change-kits": {
    "klotz": [
      "moto"
    ],
    "maxima": [
      "moto"
    ],
    "motorex": [
      "moto",
      "mx"
    ]
  },
  "moto-maintenance-oil-filters": {
    "athena": [
      "moto"
    ],
    "emgo": [
      "moto",
      "mx"
    ],
    "hiflofiltro": [
      "moto"
    ],
    "profilter": [
      "moto"
    ],
    "prox": [
      "moto"
    ],
    "twin-air": [
      "moto"
    ]
  },
  "moto-maintenance-shop-chemicals": {
    "kluber": [
      "moto",
      "mx"
    ],
    "lear-chemical": [
      "moto",
      "mx"
    ],
    "liqui-moly": [
      "moto",
      "mx"
    ],
    "lubrimatic": [
      "moto",
      "mx"
    ],
    "maxima": [
      "moto",
      "mx"
    ],
    "motorex": [
      "moto",
      "mx"
    ],
    "mystik": [
      "moto",
      "mx"
    ],
    "performance-tool": [
      "moto",
      "mx"
    ],
    "permatex": [
      "moto",
      "mx"
    ],
    "pj1": [
      "moto",
      "mx"
    ],
    "three-bond": [
      "moto",
      "mx"
    ]
  },
  "moto-maintenance-spark-plugs": {
    "ngk": [
      "moto",
      "mx"
    ]
  },
  "moto-paddock": {
    "acerbis": [
      "moto"
    ],
    "andreani": [
      "unspecified"
    ],
    "bolt": [
      "moto",
      "mx"
    ],
    "ebc": [
      "moto"
    ],
    "helix-racing": [
      "moto",
      "mx"
    ],
    "hindle": [
      "unspecified"
    ],
    "hot-cams": [
      "moto",
      "mx"
    ],
    "kuryakyn": [
      "moto"
    ],
    "motion-pro": [
      "moto",
      "mx"
    ],
    "nitron": [
      "unspecified"
    ],
    "noco": [
      "moto",
      "mx"
    ],
    "performance-tool": [
      "moto",
      "mx"
    ],
    "psychic": [
      "moto",
      "mx"
    ],
    "vortex": [
      "moto"
    ],
    "woodcraft": [
      "unspecified"
    ]
  },
  "moto-paddock-safety-wire": {
    "helix-racing": [
      "moto",
      "mx"
    ]
  },
  "moto-paddock-stands": {
    "acerbis": [
      "moto"
    ],
    "psychic": [
      "mx"
    ],
    "vortex": [
      "moto"
    ],
    "woodcraft": [
      "unspecified"
    ]
  },
  "moto-paddock-tie-downs": {
    "kuryakyn": [
      "moto"
    ],
    "vortex": [
      "moto"
    ]
  },
  "moto-paddock-tire-warmers": {
    "vortex": [
      "moto"
    ],
    "woodcraft": [
      "unspecified"
    ]
  },
  "moto-paddock-tools": {
    "andreani": [
      "unspecified"
    ],
    "bolt": [
      "moto",
      "mx"
    ],
    "ebc": [
      "moto"
    ],
    "hindle": [
      "unspecified"
    ],
    "hot-cams": [
      "moto",
      "mx"
    ],
    "motion-pro": [
      "moto",
      "mx"
    ],
    "nitron": [
      "unspecified"
    ],
    "noco": [
      "moto",
      "mx"
    ],
    "performance-tool": [
      "moto",
      "mx"
    ],
    "psychic": [
      "moto",
      "mx"
    ],
    "vortex": [
      "moto"
    ],
    "woodcraft": [
      "unspecified"
    ]
  },
  "moto-protection": {
    "acerbis": [
      "moto"
    ],
    "armour-bodies": [
      "unspecified"
    ],
    "kuryakyn": [
      "moto"
    ],
    "maier-plastics": [
      "moto",
      "mx"
    ],
    "polisport": [
      "moto",
      "mx"
    ],
    "psychic": [
      "mx"
    ],
    "renthal": [
      "moto",
      "mx"
    ],
    "vortex": [
      "moto"
    ],
    "woodcraft": [
      "unspecified"
    ]
  },
  "moto-protection-axle-sliders": {
    "woodcraft": [
      "unspecified"
    ]
  },
  "moto-protection-body": {
    "acerbis": [
      "moto"
    ],
    "armour-bodies": [
      "unspecified"
    ],
    "polisport": [
      "mx",
      "unspecified"
    ],
    "woodcraft": [
      "unspecified"
    ]
  },
  "moto-protection-chain-guides": {
    "acerbis": [
      "moto"
    ],
    "polisport": [
      "mx",
      "unspecified"
    ],
    "psychic": [
      "mx"
    ],
    "woodcraft": [
      "unspecified"
    ]
  },
  "moto-protection-disc-guards": {
    "acerbis": [
      "moto"
    ],
    "polisport": [
      "mx"
    ],
    "psychic": [
      "mx"
    ]
  },
  "moto-protection-engine-covers": {
    "acerbis": [
      "moto"
    ],
    "polisport": [
      "mx",
      "unspecified"
    ],
    "psychic": [
      "mx"
    ],
    "vortex": [
      "moto"
    ],
    "woodcraft": [
      "unspecified"
    ]
  },
  "moto-protection-fenders": {
    "acerbis": [
      "moto"
    ],
    "maier-plastics": [
      "moto",
      "mx"
    ],
    "polisport": [
      "moto",
      "mx",
      "unspecified"
    ]
  },
  "moto-protection-fork-guards": {
    "acerbis": [
      "moto"
    ],
    "polisport": [
      "mx",
      "unspecified"
    ]
  },
  "moto-protection-frame-guards": {
    "acerbis": [
      "moto"
    ]
  },
  "moto-protection-frame-sliders": {
    "vortex": [
      "moto"
    ],
    "woodcraft": [
      "unspecified"
    ]
  },
  "moto-protection-handguards": {
    "acerbis": [
      "moto"
    ],
    "maier-plastics": [
      "mx"
    ],
    "polisport": [
      "moto",
      "mx",
      "unspecified"
    ],
    "progrip": [
      "moto"
    ],
    "renthal": [
      "moto",
      "mx"
    ],
    "vortex": [
      "moto"
    ],
    "woodcraft": [
      "unspecified"
    ]
  },
  "moto-protection-number-plates": {
    "acerbis": [
      "moto"
    ],
    "polisport": [
      "mx",
      "unspecified"
    ]
  },
  "moto-protection-skid-plates": {
    "acerbis": [
      "moto"
    ],
    "polisport": [
      "mx",
      "unspecified"
    ]
  },
  "moto-protection-spools": {
    "vortex": [
      "moto"
    ],
    "woodcraft": [
      "unspecified"
    ]
  },
  "moto-styling": {
    "acerbis": [
      "moto"
    ],
    "armour-bodies": [
      "unspecified"
    ],
    "biker-s-choice": [
      "moto",
      "mx"
    ],
    "crg": [
      "moto"
    ],
    "emgo": [
      "moto",
      "mx"
    ],
    "kuryakyn": [
      "moto"
    ],
    "new-rage-cycles": [
      "moto"
    ],
    "vortex": [
      "moto"
    ],
    "woodcraft": [
      "unspecified"
    ]
  },
  "moto-styling-backrests": {
    "kuryakyn": [
      "moto"
    ]
  },
  "moto-styling-bar-ends": {
    "emgo": [
      "moto",
      "mx"
    ],
    "kuryakyn": [
      "moto"
    ],
    "vortex": [
      "moto"
    ],
    "woodcraft": [
      "unspecified"
    ]
  },
  "moto-styling-engine-trim": {
    "kuryakyn": [
      "moto"
    ]
  },
  "moto-styling-fender-eliminators": {
    "kuryakyn": [
      "moto"
    ],
    "new-rage-cycles": [
      "moto"
    ]
  },
  "moto-styling-luggage": {
    "kuryakyn": [
      "moto"
    ]
  },
  "moto-styling-mirrors": {
    "acerbis": [
      "moto"
    ],
    "crg": [
      "moto"
    ],
    "kuryakyn": [
      "moto"
    ],
    "new-rage-cycles": [
      "moto"
    ],
    "vortex": [
      "moto"
    ],
    "woodcraft": [
      "unspecified"
    ]
  },
  "moto-styling-seats": {
    "armour-bodies": [
      "unspecified"
    ]
  },
  "moto-styling-tail-lights": {
    "acerbis": [
      "moto"
    ],
    "kuryakyn": [
      "moto"
    ],
    "new-rage-cycles": [
      "moto"
    ]
  },
  "moto-styling-turn-signals": {
    "kuryakyn": [
      "moto"
    ],
    "new-rage-cycles": [
      "moto"
    ]
  },
  "moto-suspension": {
    "all-balls-racing": [
      "moto",
      "mx"
    ],
    "andreani": [
      "moto",
      "mx",
      "unspecified"
    ],
    "bitubo": [
      "moto"
    ],
    "nitron": [
      "moto",
      "unspecified"
    ],
    "ohlins": [
      "moto"
    ],
    "vortex": [
      "moto"
    ],
    "woodcraft": [
      "unspecified"
    ]
  },
  "moto-suspension-fork-cartridge": {
    "andreani": [
      "moto",
      "mx",
      "unspecified"
    ],
    "bitubo": [
      "moto"
    ],
    "nitron": [
      "unspecified"
    ],
    "ohlins": [
      "moto"
    ]
  },
  "moto-suspension-fork-seals": {
    "all-balls-racing": [
      "moto",
      "mx"
    ],
    "andreani": [
      "moto"
    ],
    "bitubo": [
      "moto"
    ]
  },
  "moto-suspension-fork-springs": {
    "andreani": [
      "mx",
      "unspecified"
    ],
    "bitubo": [
      "moto"
    ],
    "nitron": [
      "unspecified"
    ],
    "ohlins": [
      "moto"
    ]
  },
  "moto-suspension-linkage": {
    "all-balls-racing": [
      "moto",
      "mx"
    ],
    "vortex": [
      "moto"
    ]
  },
  "moto-suspension-shock": {
    "andreani": [
      "unspecified"
    ],
    "bitubo": [
      "moto"
    ],
    "nitron": [
      "unspecified"
    ],
    "ohlins": [
      "moto"
    ]
  },
  "moto-suspension-spares": {
    "andreani": [
      "moto"
    ],
    "nitron": [
      "moto"
    ]
  },
  "moto-suspension-triple-clamps": {
    "woodcraft": [
      "unspecified"
    ]
  },
  "moto-tires": {
    "avon": [
      "moto",
      "mx"
    ],
    "bridgestone": [
      "moto",
      "mx"
    ],
    "continental": [
      "moto",
      "mx"
    ],
    "dunlop": [
      "moto",
      "mx"
    ],
    "kenda": [
      "moto",
      "mx"
    ],
    "maxxis": [
      "mx"
    ],
    "motion-pro": [
      "moto",
      "mx"
    ],
    "pirelli": [
      "moto",
      "mx"
    ],
    "protaper": [
      "mx"
    ],
    "vee-rubber": [
      "moto",
      "mx"
    ]
  },
  "moto-tires-adventure": {
    "avon": [
      "moto",
      "mx"
    ],
    "bridgestone": [
      "moto",
      "mx"
    ],
    "continental": [
      "moto",
      "mx"
    ],
    "dunlop": [
      "moto",
      "mx"
    ],
    "kenda": [
      "moto",
      "mx"
    ],
    "pirelli": [
      "moto",
      "mx"
    ]
  },
  "moto-tires-classic": {
    "avon": [
      "moto"
    ],
    "bridgestone": [
      "moto"
    ],
    "continental": [
      "moto"
    ],
    "dunlop": [
      "moto"
    ]
  },
  "moto-tires-cruiser": {
    "avon": [
      "moto"
    ],
    "bridgestone": [
      "moto"
    ],
    "dunlop": [
      "moto"
    ],
    "kenda": [
      "moto"
    ]
  },
  "moto-tires-dualsport": {
    "bridgestone": [
      "moto",
      "mx"
    ],
    "dunlop": [
      "moto",
      "mx"
    ],
    "kenda": [
      "moto",
      "mx"
    ],
    "pirelli": [
      "moto",
      "mx"
    ],
    "vee-rubber": [
      "moto"
    ]
  },
  "moto-tires-enduro": {
    "bridgestone": [
      "mx"
    ],
    "dunlop": [
      "mx"
    ],
    "kenda": [
      "mx"
    ],
    "maxxis": [
      "mx"
    ],
    "pirelli": [
      "mx"
    ],
    "vee-rubber": [
      "moto"
    ]
  },
  "moto-tires-mx": {
    "bridgestone": [
      "mx"
    ]
  },
  "moto-tires-mx-hard": {
    "bridgestone": [
      "mx"
    ],
    "dunlop": [
      "mx"
    ],
    "kenda": [
      "mx"
    ],
    "maxxis": [
      "mx"
    ],
    "pirelli": [
      "mx",
      "unspecified"
    ]
  },
  "moto-tires-mx-intermediate": {
    "bridgestone": [
      "mx",
      "unspecified"
    ],
    "dunlop": [
      "mx"
    ],
    "kenda": [
      "moto",
      "mx"
    ],
    "maxxis": [
      "mx"
    ],
    "pirelli": [
      "mx"
    ],
    "protaper": [
      "mx"
    ]
  },
  "moto-tires-mx-soft": {
    "bridgestone": [
      "mx"
    ],
    "dunlop": [
      "mx"
    ],
    "kenda": [
      "mx"
    ],
    "maxxis": [
      "mx",
      "unspecified"
    ],
    "pirelli": [
      "mx",
      "unspecified"
    ],
    "protaper": [
      "mx"
    ]
  },
  "moto-tires-scooter": {
    "avon": [
      "moto"
    ],
    "bridgestone": [
      "moto"
    ],
    "continental": [
      "moto"
    ],
    "dunlop": [
      "moto"
    ],
    "kenda": [
      "moto"
    ],
    "pirelli": [
      "moto"
    ]
  },
  "moto-tires-sport": {
    "bridgestone": [
      "moto"
    ],
    "continental": [
      "moto"
    ],
    "dunlop": [
      "moto"
    ],
    "pirelli": [
      "moto"
    ]
  },
  "moto-tires-sport-touring": {
    "avon": [
      "moto"
    ],
    "bridgestone": [
      "moto"
    ],
    "continental": [
      "moto"
    ],
    "dunlop": [
      "moto"
    ],
    "kenda": [
      "moto"
    ],
    "pirelli": [
      "moto"
    ]
  },
  "moto-tires-supersport": {
    "avon": [
      "moto"
    ],
    "bridgestone": [
      "moto"
    ],
    "continental": [
      "moto"
    ],
    "dunlop": [
      "moto"
    ],
    "pirelli": [
      "moto"
    ]
  },
  "moto-tires-touring": {
    "bridgestone": [
      "moto"
    ],
    "dunlop": [
      "moto"
    ]
  },
  "moto-tires-track": {
    "avon": [
      "moto"
    ],
    "continental": [
      "moto"
    ],
    "dunlop": [
      "moto"
    ]
  },
  "moto-tires-trials": {
    "dunlop": [
      "mx"
    ],
    "kenda": [
      "mx"
    ],
    "pirelli": [
      "mx"
    ]
  },
  "mx-bearings": {
    "all-balls-racing": [
      "moto",
      "mx"
    ],
    "prox": [
      "moto",
      "mx"
    ]
  },
  "mx-brakes": {
    "all-balls-racing": [
      "moto",
      "mx"
    ],
    "ebc": [
      "moto",
      "mx"
    ],
    "jt-sprockets": [
      "moto",
      "mx"
    ],
    "vesrah": [
      "moto",
      "mx"
    ]
  },
  "mx-care": {
    "bio-kleen": [
      "moto",
      "mx"
    ],
    "gold-eagle": [
      "moto",
      "mx"
    ],
    "klotz": [
      "moto",
      "mx"
    ],
    "maxima": [
      "moto",
      "mx"
    ],
    "motion-pro": [
      "moto",
      "mx"
    ],
    "motorex": [
      "moto",
      "mx"
    ],
    "motul": [
      "moto",
      "mx"
    ],
    "novus": [
      "moto",
      "mx"
    ],
    "pig-spit": [
      "moto",
      "mx"
    ],
    "pj1": [
      "moto",
      "mx"
    ],
    "plexus": [
      "moto",
      "mx"
    ],
    "s100": [
      "moto",
      "mx"
    ]
  },
  "mx-clutch": {
    "all-balls-racing": [
      "moto",
      "mx"
    ],
    "ebc": [
      "moto",
      "mx"
    ],
    "vesrah": [
      "moto",
      "mx"
    ]
  },
  "mx-controls": {
    "motion-pro": [
      "moto",
      "mx"
    ],
    "oury": [
      "moto",
      "mx"
    ],
    "renthal": [
      "moto",
      "mx"
    ]
  },
  "mx-drivetrain": {
    "d-i-d": [
      "moto",
      "mx"
    ],
    "jt-sprockets": [
      "moto",
      "mx"
    ],
    "renthal": [
      "moto",
      "mx"
    ]
  },
  "mx-electrical": {
    "all-balls-racing": [
      "moto",
      "mx"
    ],
    "battery-tender": [
      "moto",
      "mx"
    ],
    "yuasa": [
      "moto",
      "mx"
    ]
  },
  "mx-engine": {
    "cometic": [
      "moto",
      "mx"
    ],
    "psychic": [
      "mx"
    ]
  },
  "mx-exhaust": {
    "big-gun": [
      "mx"
    ],
    "fmf": [
      "moto",
      "mx"
    ]
  },
  "mx-fuel": {
    "emgo": [
      "moto",
      "mx"
    ],
    "keihin": [
      "moto",
      "mx"
    ],
    "mikuni": [
      "moto",
      "mx"
    ],
    "motion-pro": [
      "moto",
      "mx"
    ],
    "visu-filter": [
      "moto",
      "mx"
    ]
  },
  "mx-graphics": {
    "factory-effex": [
      "mx"
    ]
  },
  "mx-lines": {
    "motion-pro": [
      "mx"
    ]
  },
  "mx-maintenance": {
    "all-balls-racing": [
      "moto",
      "mx"
    ],
    "athena": [
      "moto",
      "mx"
    ],
    "bikemaster": [
      "moto",
      "mx"
    ],
    "bolt": [
      "moto",
      "mx"
    ],
    "ebc": [
      "moto",
      "mx"
    ],
    "emgo": [
      "moto",
      "mx"
    ],
    "engine-ice": [
      "moto",
      "mx"
    ],
    "evans": [
      "moto",
      "mx"
    ],
    "gold-eagle": [
      "moto",
      "mx"
    ],
    "hiflofiltro": [
      "moto",
      "mx"
    ],
    "k100": [
      "moto",
      "mx"
    ],
    "klotz": [
      "moto",
      "mx"
    ],
    "kluber": [
      "moto",
      "mx"
    ],
    "lear-chemical": [
      "moto",
      "mx"
    ],
    "len-performance": [
      "moto",
      "mx"
    ],
    "liqui-moly": [
      "moto",
      "mx"
    ],
    "lubrimatic": [
      "moto",
      "mx"
    ],
    "maier-plastics": [
      "mx"
    ],
    "maxima": [
      "moto",
      "mx"
    ],
    "motion-pro": [
      "moto",
      "mx"
    ],
    "motorex": [
      "moto",
      "mx"
    ],
    "motul": [
      "moto",
      "mx"
    ],
    "mystik": [
      "moto",
      "mx"
    ],
    "ngk": [
      "moto",
      "mx"
    ],
    "performance-tool": [
      "moto",
      "mx"
    ],
    "permatex": [
      "moto",
      "mx"
    ],
    "pj1": [
      "moto",
      "mx"
    ],
    "polisport": [
      "mx"
    ],
    "prox": [
      "moto",
      "mx"
    ],
    "psychic": [
      "mx"
    ],
    "renthal": [
      "moto",
      "mx"
    ],
    "s-s-cycle": [
      "moto",
      "mx"
    ],
    "star-brite": [
      "moto",
      "mx"
    ],
    "three-bond": [
      "moto",
      "mx"
    ],
    "twin-air": [
      "moto",
      "mx"
    ],
    "uni-filter": [
      "moto",
      "mx"
    ],
    "vibrant": [
      "moto",
      "mx"
    ]
  },
  "mx-paddock": {
    "bolt": [
      "moto",
      "mx"
    ],
    "helix-racing": [
      "moto",
      "mx"
    ],
    "hot-cams": [
      "moto",
      "mx"
    ],
    "motion-pro": [
      "moto",
      "mx"
    ],
    "noco": [
      "moto",
      "mx"
    ],
    "performance-tool": [
      "moto",
      "mx"
    ],
    "psychic": [
      "moto",
      "mx"
    ]
  },
  "mx-protection": {
    "maier-plastics": [
      "moto",
      "mx"
    ],
    "polisport": [
      "moto",
      "mx"
    ],
    "psychic": [
      "mx"
    ],
    "renthal": [
      "moto",
      "mx"
    ]
  },
  "mx-styling": {
    "biker-s-choice": [
      "moto",
      "mx"
    ],
    "emgo": [
      "moto",
      "mx"
    ]
  },
  "mx-suspension": {
    "all-balls-racing": [
      "moto",
      "mx"
    ],
    "andreani": [
      "mx"
    ]
  },
  "mx-tires": {
    "avon": [
      "moto",
      "mx"
    ],
    "bridgestone": [
      "moto",
      "mx"
    ],
    "continental": [
      "moto",
      "mx"
    ],
    "dunlop": [
      "moto",
      "mx"
    ],
    "kenda": [
      "moto",
      "mx"
    ],
    "maxxis": [
      "mx"
    ],
    "motion-pro": [
      "moto",
      "mx"
    ],
    "pirelli": [
      "moto",
      "mx"
    ],
    "protaper": [
      "mx"
    ],
    "vee-rubber": [
      "moto",
      "mx"
    ]
  }
};
